<template>
  <section class="bg-cream-100 overflow-hidden">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20">
      <div class="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">

        <!-- Left: text content -->
        <div class="flex-1 text-center lg:text-left">
          <!-- Daily badge -->
          <span class="badge mb-4 inline-block">
            🍽️ Today's Menu is Live!
          </span>

          <h3 class="font-display text-2xl sm:text-3xl lg:text-4xl font-bold text-accent leading-tight mb-4">
            Fresh Home-Cooked<br />
            <span class="text-brand">Meals Delivered</span>
            To Your Door
          </h3>

          <p class="text-accent/70 text-base sm:text-lg mb-6 sm:mb-8 max-w-lg mx-auto lg:mx-0">
            Every day we cook a new menu — real home food made with love.
            Browse today's dishes, place your order, and we'll deliver it fresh.
          </p>

          <div class="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start">
            <router-link to="/menu" class="btn-primary text-base px-8 py-3">
              <span>See Today's Menu</span>
              <ArrowRightIcon class="w-5 h-5" />
            </router-link>
            <router-link to="/about" class="btn-outline text-base px-8 py-3">
              How It Works
            </router-link>
          </div>

          <!-- Quick stats -->
          <div class="mt-8 flex flex-wrap justify-center lg:justify-start gap-4 sm:gap-6 lg:gap-8">
            <div v-for="stat in stats" :key="stat.label" class="text-center lg:text-left">
              <p class="font-display text-2xl font-bold text-brand">{{ stat.value }}</p>
              <p class="text-sm text-accent/60 mt-0.5">{{ stat.label }}</p>
            </div>
          </div>
        </div>

        <!-- Right: hero visual card -->
        <div class="flex-1 w-full max-w-md lg:max-w-none">
          <div class="relative">
            <!-- Main card -->
            <div class="card p-6 bg-white">
              <div class="bg-cream-200 rounded-2xl h-52 sm:h-64 md:h-72 lg:h-80 flex items-center justify-center mb-4">
                <img
                  src="@/assets/logo-final.png"
                  alt="HomeSweet Bites — Home Cooked Meals"
                  class="h-48 w-auto object-contain drop-shadow-lg"
                />
              </div>
              <!-- Today's highlight dish pill -->
              <div class="flex items-center justify-between">
                <div>
                  <p class="text-xs text-accent/50 font-medium uppercase tracking-wide">Today's Special</p>
                  <p class="font-display font-bold text-accent text-lg">Chef's Daily Plate</p>
                </div>
                <router-link to="/menu" class="btn-primary text-sm px-4 py-2">
                  Order
                </router-link>
              </div>
            </div>

            <!-- Floating delivery badge -->
            <div class="absolute -top-4 -right-4 bg-brand text-white rounded-2xl px-4 py-2 shadow-lg text-sm font-semibold hidden sm:block">
              🛵 Fast Delivery
            </div>

            <!-- Floating rating badge -->
            <div class="absolute -bottom-4 -left-4 bg-white rounded-2xl px-4 py-3 shadow-card text-sm font-semibold text-accent flex items-center gap-2 hidden sm:flex">
              <span class="text-yellow-400 text-base">★★★★★</span>
              <span>4.9 Rating</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { ArrowRightIcon } from '@heroicons/vue/24/outline'

export default defineComponent({
  name: 'HeroBanner',
  components: { ArrowRightIcon },
  setup () {
    const stats = [
      { value: '100+', label: 'Happy Customers' },
      { value: 'Daily', label: 'Fresh Menu' },
      { value: '30min', label: 'Avg. Delivery' }
    ]
    return { stats }
  }
})
</script>
